webpackJsonp([173482386001864],{

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	function _objectWithoutProperties(obj, keys) {
	  var target = {};for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
	  }return target;
	}
	
	exports.default = function (_ref) {
	  var _ref$styles = _ref.styles,
	      styles = _ref$styles === undefined ? {} : _ref$styles,
	      props = _objectWithoutProperties(_ref, ["styles"]);
	
	  return _react2.default.createElement("svg", _extends({ width: "27", height: "11", xmlns: "http://www.w3.org/2000/svg" }, props), _react2.default.createElement("path", { d: "M5.5 11l.6-.6-4.4-4.5h15.2L21 10l.6-.6-3.4-3.5h4.1l4.1 4.1.6-.6-3.7-3.8v-.2L27 1.6l-.6-.6-4.1 4.1h-4.1l3.4-3.5L21 1l-4.1 4.1H1.7L6.1.6 5.5 0 0 5.5z", fill: "currentColor", fillRule: "evenodd" }));
	};

/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.pageQuery = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _glamorous = __webpack_require__(5);
	
	var _glamorous2 = _interopRequireDefault(_glamorous);
	
	var _reactHelmet = __webpack_require__(59);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _lodash = __webpack_require__(41);
	
	var _components = __webpack_require__(12);
	
	var _style = __webpack_require__(7);
	
	var _Arrow = __webpack_require__(161);
	
	var _Arrow2 = _interopRequireDefault(_Arrow);
	
	var _analytics = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GalleryTitle = _glamorous2.default.h1.withConfig({
	  displayName: 'gallery__GalleryTitle'
	})(_extends({}, _style.typography.title1, _style.margin.y(4), {
	  textAlign: 'center'
	}));
	
	var BackButton = _glamorous2.default.button.withConfig({
	  displayName: 'gallery__BackButton'
	})(_extends({}, _style.margin.top(4), _style.margin.left(2), _style.typography.nav, _style.transition.medium('color'), {
	  color: _style.colors.primary,
	  ':hover': {
	    color: _style.colors.primaryDark,
	    '> i': {
	      transform: 'translateX(-3px)'
	    }
	  },
	  ':focus': {
	    color: _style.colors.primaryDark,
	    '> i': {
	      transform: 'translateX(-3px)'
	    }
	  },
	  '> i': _extends({}, _style.transition.medium('transform'), _style.margin.right(2), {
	    display: 'inline-block'
	  })
	})).withProps({ onMouseDown: function onMouseDown(e) {
	    return e.preventDefault();
	  } });
	
	var capitalize = function capitalize(string) {
	  return '' + string[0].toUpperCase() + string.slice(1);
	};
	
	var countLines = function countLines(element) {
	  var divHeight = element.offsetHeight;
	  var lineHeight = parseInt(getComputedStyle(element).lineHeight);
	  return divHeight / lineHeight;
	};
	
	var mapFilterToString = function mapFilterToString(filter) {
	  return filter === '*' ? 'All' : capitalize(filter);
	};
	
	var GalleryTemplate = function (_React$Component) {
	  _inherits(GalleryTemplate, _React$Component);
	
	  function GalleryTemplate() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, GalleryTemplate);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GalleryTemplate.__proto__ || Object.getPrototypeOf(GalleryTemplate)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isOpen: false,
	      options: { index: -1 },
	      centerDescription: false
	    }, _this.onResize = (0, _lodash.throttle)(function () {
	      _this.maybeCenterDescription();
	    }, 300), _this.setDescription = function (ref) {
	      _this.description = ref;
	      _this.maybeCenterDescription();
	    }, _this.maybeCenterDescription = function () {
	      if (_this.description) {
	        var descriptionElement = _this.description.firstElementChild; // flowlint-line unclear-type:off
	
	        if (countLines(descriptionElement) === 1) {
	          _this.setState({ centerDescription: true });
	        } else {
	          _this.setState({ centerDescription: false });
	        }
	      }
	    }, _this.openSlideshow = function (itemIndex) {
	      return function (e) {
	        e.preventDefault();
	        var getThumbBoundsFn = function getThumbBoundsFn(index) {
	          var thumbnail = _this.thumbnails[index];
	          if (thumbnail == null) return null;
	          var img = thumbnail.getElementsByTagName('img')[0] || thumbnail.getElementsByTagName('video')[0];
	          var pageYScroll = window.pageYOffset || document.documentElement && document.documentElement.scrollTop;
	          var rect = img.getBoundingClientRect();
	          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
	        };
	
	        _this.setState({
	          isOpen: true,
	          options: {
	            index: itemIndex,
	            getThumbBoundsFn: getThumbBoundsFn
	          }
	        });
	
	        var location = _this.props.location;
	
	        (0, _analytics.trackSlideshowOpen)(location);
	      };
	    }, _this.handleClose = function () {
	      _this.setState({
	        isOpen: false
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(GalleryTemplate, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('resize', this.onResize);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.onResize);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          isOpen = _state.isOpen,
	          options = _state.options,
	          centerDescription = _state.centerDescription;
	      var _props = this.props,
	          data = _props.data,
	          location = _props.location,
	          history = _props.history;
	      var state = location.state;
	
	
	      var gallery = data.contentfulGallery;
	      var description = gallery.description != null ? gallery.description.childMarkdownRemark : undefined;
	
	      var siteUrl = data.site.siteMetadata.siteUrl;
	
	      return React.createElement(
	        _components.Wrapper,
	        null,
	        React.createElement(
	          _reactHelmet2.default,
	          null,
	          React.createElement(
	            'title',
	            null,
	            gallery.title
	          ),
	          React.createElement('meta', {
	            name: 'description',
	            content: 'Photos of ' + gallery.title + ' by Melissa O\u2019Hearn'
	          }),
	          React.createElement('link', {
	            rel: 'canonical',
	            href: '' + siteUrl + location.pathname.replace(/\/$/, '')
	          })
	        ),
	        state && state.filter && React.createElement(
	          BackButton,
	          { onClick: history.goBack },
	          React.createElement(
	            'i',
	            null,
	            React.createElement(_Arrow2.default, null)
	          ),
	          'Back to ' + mapFilterToString(state.filter)
	        ),
	        React.createElement(
	          GalleryTitle,
	          null,
	          gallery.title
	        ),
	        description && React.createElement(_components.Markdown, {
	          alignCenter: centerDescription,
	          innerRef: this.setDescription,
	          dangerouslySetInnerHTML: {
	            __html: description.html
	          }
	        }),
	        React.createElement(
	          _components.Grid,
	          null,
	          gallery.images.map(function (_ref2, index) {
	            var id = _ref2.id,
	                image = _objectWithoutProperties(_ref2, ['id']);
	
	            return React.createElement(
	              _components.Grid.Item,
	              { key: id },
	              React.createElement(
	                _components.SlideshowTrigger,
	                {
	                  onClick: _this2.openSlideshow(index),
	                  innerRef: function innerRef(node) {
	                    _this2.thumbnails = _this2.thumbnails || [];
	                    _this2.thumbnails[index] = node;
	                  }
	                },
	                React.createElement(_components.GalleryImage, { image: _extends({ id: id }, image) })
	              )
	            );
	          })
	        ),
	        isOpen && React.createElement(_components.Slideshow, {
	          images: gallery.images,
	          options: options,
	          location: location
	        })
	      );
	    }
	  }]);
	
	  return GalleryTemplate;
	}(React.Component);
	
	exports.default = GalleryTemplate;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-gallery-js-410397f315fa89bb224f.js